import { masterType } from "../type";
const paginationInState = {
  page_no: 1,
  limit: 25,
  totalPage: 1,
};
const initialState = {
  modalList: undefined,
  modalDirList: undefined,
  commonData: undefined,
  column:undefined,
  message: undefined,
  model: undefined,
  modelMasterId: undefined,
  pagination: {
    ...paginationInState,
  },
  ExcelFile: "",
  modalFilterData: [],
  error: undefined,
  isLoading: false,
  modifiedCount: undefined
};

const masterReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;
  const { data, pagination, model, modelMasterId, count } = payload;

 
  switch (type) {
    case masterType.GET_MODEL_LIST:
      return { ...state, modalList: data, isLoading: false, error: undefined };
    case masterType.LOADING_MASTER:
      return { ...state, isLoading: payload };
    case masterType.ERROR_MASTER:
      
      return { ...state, error: payload, message: data };
    case masterType.GET_DATA:
      return {
        ...state,
        commonData: data,
        column:payload.column,
        modalFilterData: payload.modalFilterData,
        pagination: {
          ...paginationInState,
          ...pagination,
        },
        model,
        modelMasterId,
        isLoading: false,
      };

      case masterType.ADD_MODEL:
        
        if (!data || !data.data) {
          return {
            ...state,
            message: data,
          };
        }
        console.log(data)
        return {
          ...state,
          message: data,
          modalList: [
            ...(state.modalList || []), // fallback if modalList is undefined
            payload.modeList,
          ],
        };
      
    case masterType.MODEL_LIST:
      return {
        ...state,
        modalDirList: data,
        isLoading: false,
        error: undefined,
      };

    case masterType.DELETE_MODEL:
      return {
        ...state,
        isLoading: false,
        error: undefined,
        commonData: undefined,
        pagination: { ...paginationInState },
        model: "",
        modelMasterId: undefined,
        modalList: state.modalList.filter(
          (item) => item.modelId !== modelMasterId
        ),
      };

    case masterType.DOWNLOAD_EXCEL:
      return {
        ...state,
        isLoading: false,
        error: undefined,
        ExcelFile: data,
      };

    case masterType.UPLOAD_EXCEL:
      return {
        ...state,
        message: data,
        modifiedCount: count,
        error: undefined,
      };

    case masterType.RESET_MASTER_MESSAGE:
      return {
        ...state,
        message: undefined,
      };

    case masterType.UPLOAD_COLUMN_NAME_EXCEL:
      return {
        ...state,
        message:data
      };
    default:
      return state;
  }
};
export default masterReducer;
